export class CreateThreatHuntingScanRequestResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "scanRequest",
            "baseName": "scanRequest",
            "type": "ThreatHuntingScanRequest",
            "format": ""
        },
        {
            "name": "deduplicated",
            "baseName": "deduplicated",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CreateThreatHuntingScanRequestResponse.attributeTypeMap;
    }
    constructor() {
    }
}
